import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '@/config';
import { renderIntlLabel } from '@/utils';
import { getTimeByUtcOffset } from '@/utils/intl';
import NoCouponData from '../NoCouponData';

const columns: ColumnsType<any> = [
  { title: renderIntlLabel('guest_coupon_label_card_coupon_name'), dataIndex: 'couponName' },
  { title: renderIntlLabel('guest_coupon_label_send_remark'), dataIndex: 'remark' },
  { title: renderIntlLabel('guest_coupon_label_source'), dataIndex: 'source' },
  {
    title: renderIntlLabel('guest_coupon_label_send_Time'),
    dataIndex: 'startTime',
    render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
    width: 200,
  },
  {
    title: renderIntlLabel('guest_coupon_label_use_status'),
    dataIndex: 'status',
    render: (val) =>
      val === 1
        ? renderIntlLabel('guest_coupon_tab_have_been_used')
        : renderIntlLabel('guest_coupon_tab_have_been_unused'),
    width: 100,
  },
];

const usedRemainingColumns: ColumnsType<any> = [
  {
    title: renderIntlLabel('guest_coupon_label_use_time'),
    dataIndex: 'updateTime',
    render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
    fixed: 'right',
  },
  {
    title: renderIntlLabel('guest_coupon_label_use_store'),
    dataIndex: 'operateHotelName',
    fixed: 'right',
  },
  { title: renderIntlLabel('guest_coupon_label_operator'), dataIndex: 'operator', fixed: 'right' },
];

const ManualTabItem = ({ dataSource = [], loading, isUsed = false }) => {
  return (
    <>
      {Array.isArray(dataSource) && dataSource.length ? (
        <Table
          rowKey="id"
          columns={isUsed ? columns.concat(usedRemainingColumns) : columns}
          dataSource={dataSource}
          loading={loading}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
      ) : (
        <NoCouponData />
      )}
    </>
  );
};

export default ManualTabItem;
